import { Grid, CardContent } from "@mui/material";
import { IFullFlight, ICustomTab, IGroundEvent, isFlight } from "@vmosolutions/oc-interfaces";

import { FormHeader } from "../helpers";
import { CustomEvent } from "src/components/Custom/CustomEvent";
import { IFormHandle } from "../helpers";

interface ICustomTabProps {
  fullEvent: IFullFlight | IGroundEvent; // Id of the flight or ground event to retrieve and edit if provided.
  customEventTab: ICustomTab;
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus: (statusMessage: string) => void;
  setLoadedEvent: (values: IFullFlight | IGroundEvent) => void;
  registerFormHandle?: (tabId: string, handle: IFormHandle | null) => void;
  saveAllDirtyTabs?: (excludeTabId?: string) => Promise<void>;
}

/**
 * Custom Properties Tab
 * @param props -
 */
export const CustomTab = (props: ICustomTabProps): JSX.Element => {
  const { fullEvent, customEventTab, updateTabState, mosaicId, setAPICallStatus, setLoadedEvent, registerFormHandle, saveAllDirtyTabs } = props;
  const { title, description, customSchema } = customEventTab ?? {};

  return (
    <CardContent id={`${mosaicId}-custom_${title}-editor`} className="form_card custom">
      <Grid container direction="column">
        <FormHeader title={title} subtitle={description} />
        <CustomEvent
          windowId={mosaicId}
          eventId={fullEvent?._id}
          customValues={fullEvent?.custom}
          customSchema={customSchema}
          updateTabState={updateTabState}
          setLoadedEvent={setLoadedEvent}
          isFlight={isFlight(fullEvent)}
          registerFormHandle={registerFormHandle}
          saveAllDirtyTabs={saveAllDirtyTabs}
          formTabId={title}
        />
      </Grid>
    </CardContent>
  );
};
